import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import useStoreTranslation from 'hooks/useStoreTranslation';
import MENU_ENTRIES, { MenuRoles, MenuDisplay } from 'utils/menuEntries';

import { Container, MenuItem, MenuIcon, MenuName, Icon } from './styles';

const DesktopMenu = () => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const userData = useSelector((state: RootState) => state.user.accountResult);

  const isAdmin = userData?.type === 'admin';
  const isApprover = !!userData?.isGroupApprover;
  const isTravelArranger = userData?.isTravelArranger ?? false;

  const {
    location: { pathname },
  } = history;

  return (
    <Container>
      {MENU_ENTRIES.filter((entry) => {
        if (!entry.display.includes(MenuDisplay.Desktop)) return false;

        if (entry.roles.includes(MenuRoles.Traveler)) return true;
        if (entry.roles.includes(MenuRoles.Approver) && isApprover) return true;
        if (entry.roles.includes(MenuRoles.TravelArranger) && isTravelArranger) return true;
        if (entry.roles.includes(MenuRoles.Admin) && isAdmin) return true;
        return false;
      }).map((entry) => {
        const isEntryAdmin = entry.roles.includes(MenuRoles.Admin);
        const isEntryActive =
          pathname !== '/' && [...entry.nestedRoutes, entry.mainRoute].some((route) => pathname.startsWith(route));

        return (
          <MenuItem
            key={entry.mainRoute}
            admin={isEntryAdmin}
            active={isEntryActive}
            onClick={() => history.push(entry.mainRoute)}
          >
            <MenuIcon admin={isEntryAdmin} active={isEntryActive}>
              <Icon small={entry.iconSmall} src={entry.iconSrc} />
            </MenuIcon>
            <MenuName admin={isEntryAdmin} active={isEntryActive}>
              {t(entry.name)}
            </MenuName>
          </MenuItem>
        );
      })}
    </Container>
  );
};

export default DesktopMenu;
